import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import classnames from 'classnames';
import flow from 'lodash/flow';

import Validated from 'components/util/Validated';

import AssetsSchemas from 'schemas/assets_schemas';

import AssetsFormSections from 'components/assets/form_sections';

import { Form } from 'common/components';

const AssetsForm = ({
  accounts = [],
  catalogs = {},
  companyId = '',
  costCenters = [],
  depreciations = [],
  employees = [],
  errors = {},
  files = [],
  handleFileAdd = () => {},
  handleFileRemove = () => {},
  handleSubmit = () => {},
  handleValueChange,
  isLoading = false,
  isSaving = false,
  isSubmitted = false,
  locations,
  handleGroupChange, //Groups
  handleCustomFieldChange, //Groups
  groups, //Groups
  projects = [],
  providers = [],
  subaccounts = [],
  subcompanyId = '',
  sublocations = [],
  t = () => {},
  values = {},
  asset_levels = [],
}) => {
  const haveCustomFields = (asset) => {
    return !!(
      asset &&
      ((asset._account && asset._account._customFields && asset._account._customFields.length) ||
        (asset._subaccount &&
          asset._subaccount._customFields &&
          asset._subaccount._customFields.length))
    );
  };

  return (
    <form onSubmit={handleSubmit} noValidate autoComplete="false">
      <AssetsFormSections.Description
        catalogs={catalogs}
        errors={errors}
        handleValueChange={handleValueChange}
        isSubmitted={isSubmitted}
        isLoading={isLoading}
        values={values}
      />

      <AssetsFormSections.General
        catalogs={catalogs}
        errors={errors}
        handleValueChange={handleValueChange}
        isSubmitted={isSubmitted}
        isLoading={isLoading}
        values={values}
        asset_levels={asset_levels}
      />

      <AssetsFormSections.Location
        employees={employees}
        locations={locations}
        sublocations={sublocations}
        errors={errors}
        handleValueChange={handleValueChange}
        isSubmitted={isSubmitted}
        isLoading={isLoading}
        values={values}
      />

      <AssetsFormSections.Buy
        catalogs={catalogs}
        costCenters={costCenters}
        errors={errors}
        handleValueChange={handleValueChange}
        isSubmitted={isSubmitted}
        isLoading={isLoading}
        providers={providers}
        values={values}
      />

      <AssetsFormSections.Accountant
        accounts={accounts}
        depreciations={depreciations}
        subaccounts={subaccounts}
        catalogs={catalogs}
        errors={errors}
        handleValueChange={handleValueChange}
        isSubmitted={isSubmitted}
        isLoading={isLoading}
        values={values}
      />

      <AssetsFormSections.Project
        projects={projects}
        errors={errors}
        handleValueChange={handleValueChange}
        isSubmitted={isSubmitted}
        isLoading={isLoading}
        values={values}
      />

      <AssetsFormSections.Assurance
        catalogs={catalogs}
        errors={errors}
        handleValueChange={handleValueChange}
        isSubmitted={isSubmitted}
        isLoading={isLoading}
        values={values}
      />
      
      <AssetsFormSections.Bill
        errors={errors}
        handleValueChange={handleValueChange}
        isSubmitted={isSubmitted}
        isLoading={isLoading}
        values={values}
      />

      <AssetsFormSections.Codes values={values} />

      {haveCustomFields(values) && (
        <AssetsFormSections.CustomFields
          errors={errors}
          handleValueChange={handleValueChange}
          isSubmitted={isSubmitted}
          isLoading={isLoading}
          values={values}
        />
      )}

      {!values.id && (
        <AssetsFormSections.Files
          files={files}
          handleFileAdd={handleFileAdd}
          handleFileRemove={handleFileRemove}
        />
      )}

      {/* Groups */}
      <Form.CustomFields
        errors={errors}
        handleCustomFieldChange={handleCustomFieldChange}
        handleGroupChange={handleGroupChange}
        isSubmitted={isSubmitted}
        t={t}
        values={values}
        groups={groups}
      ></Form.CustomFields>
      {/* Groups */}

      <div className="col-md-12 mt-3">
        <Form.Button
          type={'submit'}
          text={t('actions.save')}
          isLoading={isSaving}
          disabled={isSaving}
          extraClassName={'pull-right btn-xs-block'}
        />

        <Form.Link
          to={`/companies/${companyId}/subcompanies/${subcompanyId}/assets`}
          className={classnames('btn btn-secondary pull-right mr-3', {
            disabled: isSaving,
          })}
        >
          {t('actions.cancel')}
        </Form.Link>
        <div className="clearfix" />
      </div>
    </form>
  );
};

AssetsForm.propTypes = {
  handleValueChange: PropTypes.func.isRequired,
};

export default flow(translate(), Validated(AssetsSchemas.add))(AssetsForm);



// WEBPACK FOOTER //
// src/components/assets/AssetsForm.js